
// import cssText from 'inline-scss:/parcel-build/core/style/critical.css';
// let style = document.getElementsByTagName('style')[0];
// style.textContent = cssText;
// console.log('cssText', cssText);

// JQuery Stuff:
// import "./import-jquery";

// import "./import-feather-icons";
// import "jquery-sticky";

// import Cookies from "js-cookie";
// import deparam from "jquery-deparam";

// Bootstrap Stuff:
// import * as Popper from "@popperjs/core"
// import { Offcanvas, Popover } from 'bootstrap';
import "./bs-toggle-color-mode";

// Slider Pro:
// import "../../node_modules/slider-pro-js/build/slider-pro";
// import "../../node_modules/daterangepicker/daterangepicker";
// import {
// 	TempusDominus,
// 	DefaultOptions,
// 	DefaultEnLocalization,
// 	DateTime, loadLocale, locale
// } from "@eonasdan/tempus-dominus";
//
// import * as TempusDominus_locale_de from "../../node_modules/@eonasdan/tempus-dominus/dist/locales/de";


// import ds81_initAutovalidatorForm from './jq-autovalidator-form_import.js';


// import {formValidation, plugins} from "./lib/formvalidation_1_8_1/es6/";
import Bootstrap5 from "./lib/formvalidation_1_8_1/es6/plugins/Bootstrap5";
// import * as Ladda from "ladda";
// import moment from 'moment';
// import 'moment/locale/de';
// moment.locale('de');

// import _ from "underscore";

// import './lib/jquery.pause.min';

// import "./jq-timed-message";

import SimpleParallax from "../../node_modules/simple-parallax-js/dist/vanilla/simpleParallaxVanilla.es";

// import PhotoSwipeLightbox from '../../node_modules/photoswipe/dist/photoswipe-lightbox.esm.js';
// import PhotoSwipe from '../../node_modules/photoswipe/dist/photoswipe.esm.js';

import { Fancybox } from "@fancyapps/ui";

export default (window.Fancybox = Fancybox);

// The debounce function receives our function as a parameter
// const debounce = (fn) => {
//     // This holds the requestAnimationFrame reference, so we can cancel it if we wish
//     let frame;
//
//     // The debounce function returns a new function that can receive a variable number of arguments
//     return (...params) => {
//         // If the frame variable has been defined, clear it now, and queue for next frame
//         if (frame) {
//             cancelAnimationFrame(frame);
//         }
//
//         // Queue our function call for the next frame
//         frame = requestAnimationFrame(() => {
//             // Call our function and pass any params we received
//             fn(...params);
//         });
//     };
// };

// const tempusDominus_icons = {
// 	type: 'icons',
// 	time: 'ci ci-clock',
// 	date: 'ci ci-calendar',
// 	up: 'ci ci-calendar-up',
// 	down: 'ci ci-calendar-down',
// 	previous: 'ci ci-calendar-prev',
// 	next: 'ci ci-calendar-next',
// 	today: 'ci ci-calendar-check',
// 	clear: 'ci calendar-trash',
// 	close: 'ci ci-close'
// };

document.addEventListener( 'DOMContentLoaded', () => {

	Fancybox.bind('[data-fancybox="gallery"]', {
		// Custom options for the first gallery
	});
	ds81_upgrade_links_to_fancybox();

	// Init header parallax:
	if(document.querySelectorAll('.parallax-image').length > 0)
	{
		const image = document.getElementsByClassName('parallax-image');
		new SimpleParallax(image, {
			delay: 0.1,
			orientation: 'down',
			scale: 2.1,
			overflow: true
		});
	}

	// Init header parallax:
	if(document.querySelectorAll('.parallax-image-up').length > 0)
	{
		const image = document.getElementsByClassName('parallax-image-up');
		new SimpleParallax(image, {
			delay: 0.1,
			orientation: 'up',
			scale: 1.5,
			overflow: false
		});
	}

	// $(window).on('resize.ds81_breakpoint_check', debounce(checkSize));
	// $(window).on('resize.ds81_picker_center', debounce(centerDatePickers));

	// $('[data-bs-toggle="popover"][data-bs-trigger="focus"]').each(function () {
	// 	const popover = new Popover($(this).get(0), {
	// 		trigger: 'focus',
	// 		options: {
	// 			fallbackPlacements: ['bottom', 'right'],
	// 		},
	// 	});
	// });

});


// set variables
// var xs;
// var sm;
// var md;
// var lg;
// var xl;
// var xxl;
// var breakpoint;
//
// // Breakpoint check helper functions ----
// // Checks if the span is set to display lock via CSS
// function checkIfBlock (target) {
//     var target = $(target).css('display') == 'block';
//     return target;
// }

// function centerDatePickers(){
//
// 	$('.daterangepicker.show-calendar').each(function () {
// 		let pickerContainer = $(this);
// 		let pickerW = ($('body').width() / 2) - (pickerContainer.width() / 2);
// 		pickerContainer.css('left',  pickerW + 'px');
// 	});
//
//
// }
//
// // function to check the sizes
// function checkSize (){
//     // Set some variables to use with the if checks below
//
//     xs = checkIfBlock('.breakpoint-check .xs');
//     sm = checkIfBlock('.breakpoint-check .sm');
//     md = checkIfBlock('.breakpoint-check .md');
//     lg = checkIfBlock('.breakpoint-check .lg');
//     xl = checkIfBlock('.breakpoint-check .xl');
//     xxl = checkIfBlock('.breakpoint-check .xxl');
//
// // add the breakpoint to the console
// // console.clear();
//     if( xs == true) {
//         breakpoint = "xs - <576px";
//         // console.log(breakpoint);
//         $("body").removeClass('xs sm md lg xl').addClass( "xs" );
//     }
//
//     if( sm == true) {
//         breakpoint = "sm - ≥576px";
//         // console.log(breakpoint);
//         $("body").removeClass('xs sm md lg xl xxl').addClass( "sm" );
//     }
//
//     if( md == true) {
//         breakpoint = "md - ≥768px";
//         // console.log(breakpoint);
//         $("body").removeClass('xs sm md lg xl xxl').addClass( "md" );
//     }
//
//     if( lg == true) {
//         breakpoint = "lg - ≥992px";
//         // console.log(breakpoint);
//         $("body").removeClass('xs sm md lg xl xxl').addClass( "lg" );
//     }
//
//     if( xl == true) {
//         breakpoint = "xl - ≥1200px";
//         // console.log(breakpoint);
//         $("body").removeClass('xs sm md lg xl xxl').addClass( "xl" );
//     }
//
//     if( xxl == true) {
//         breakpoint = "xl - ≥1400px";
//         // console.log(breakpoint);
//         $("body").removeClass('xs sm md lg xl xxl').addClass( "xxl" );
//     }
//
// }
// // end check size
//
//
// function getBreakPointName() {
//     if(typeof breakpoint === 'undefined')
//     {
//         return 'lg';
//     }
//     return breakpoint.substr(0,2);
// }
//
// function isWithinBreakpoint(checkAgainst)
// {
//     return getBreakPointName() === checkAgainst.toLowerCase();
// }
// // END Breakpoint check helper functions ----

// jQuery on ready:
// $(function() {
//
//     // Add js flag to html:
//     $('html').addClass('js-on');
//
//     // Breakpoint check
//     // $( "body" ).append( "<div style='display:none;' class='breakpoint-check'><span class='xs d-block d-sm-inline'></span><span class='sm d-sm-block d-md-inline'></span><span class='md d-md-block d-lg-inline'></span><span class='lg d-lg-block d-xl-inline'></span><span class='xl d-xl-block'></span><span class='xxl d-xxl-block'></span></div>" );
//     // checkSize();
//
//     // // Init bs offcanvas:
//     // $('#ocMainNav').data('bs-oc-ref', new Offcanvas('#ocMainNav'));
// 	//
//     // // Set bs offcanvas handlers:
//     // $('#ocMainNav').on('show.bs.offcanvas', event => {
//     //     $('.oc-nav-trigger').addClass('is-active');
//     //     $('html').addClass('menu-show');
//     //     $('.offcanvas-backdrop').on('click', function (e) {
//     //     });
//     // });
// 	//
//     // $('#ocMainNav').on('hide.bs.offcanvas', event => {
//     //     $('.oc-nav-trigger').removeClass('is-active');
//     //     $('html').removeClass('menu-show');
//     // });
//
//     // Add click handler to open/close bs offcanvas menu on main menu button click:
//     // $('.oc-nav-trigger').on('click.nav-main-toggle',function (e) {
// 	// 	e.preventDefault();
// 	// 	e.stopPropagation();
//     //     if($('html').hasClass('menu-show'))
//     //     {
//     //         $('#ocMainNav').data('bs-oc-ref').hide();
//     //     }
//     //     else
//     //     {
//     //         $('#ocMainNav').data('bs-oc-ref').show();
//     //     }
//     // });
//
//
// });

function ds81_upgrade_links_to_fancybox(){

	// Upgrade links to use fancybox:
	document.querySelectorAll('a[href]:not([data-fancybox]):not(.no-fb):not([target="_blank"])').forEach((el, index) => {
		if(!el.classList.contains('ds-fancybox-init'))
		{
			el.classList.add('ds-fancybox-init');
			el.setAttribute('data-fancybox', 'ajaxbox' + index);
			el.setAttribute('data-type', 'ajax');
			el.setAttribute('data-src', el.getAttribute('href'));
			el.setAttribute('data-filter', '#mainContent');

			Fancybox.bind('[data-fancybox="ajaxbox' + index + '"]', {
				Thumbs: false,
				groupAttr: false,
				on: {
					done: (fancybox, slide) => {
						if (fancybox.isCurrentSlide(slide)) {

							ds81_upgrade_links_to_fancybox();

						} else {

						}
					},
				},
			});

		}
	});


}